import { closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/wt-personal-info-protection",
    name: "PersonalInfoProtection",
    meta: {
      title: "个人信息保护政策",
      customBackFn: closeCurrentWebView,
      theme: "transparent",
      unusedToken: true
    },
    component: () => import("@/views/protocol/PersonalInfoProtection.vue")
  },
  {
    path: "/wt-user-service-agreement",
    name: "UserServiceAgreement",
    meta: {
      title: "用户服务协议",
      customBackFn: closeCurrentWebView,
      theme: "transparent",
      unusedToken: true
    },
    component: () => import("@/views/protocol/UserServiceAgreement.vue")
  },
  {
    path: "/wt-personal-info-list",
    name: "PersonalInfoSharingList",
    meta: {
      title: "个人信息共享清单",
      customBackFn: closeCurrentWebView,
      theme: "transparent",
      unusedToken: true
    },
    component: () => import("@/views/protocol/PersonalInfoSharingList.vue")
  },
  {
    path: "/wt-sharing-list",
    name: "ThreePartyInfoSharingList",
    meta: {
      title: "三方信息共享清单",
      customBackFn: closeCurrentWebView,
      theme: "transparent",
      unusedToken: true
    },
    component: () => import("@/views/protocol/ThreePartyInfoSharingList.vue")
  }
];
